/** After Heroes: common LoTR LCG player types, then any other types A–Z, then missing type. */
export const DECK_TYPE_ORDER = [
  "ally",
  "attachment",
  "event",
  "contract",
  "objective",
  "player-side quest",
  "treasure",
];

export function deckLineTypeKey(typeName) {
  const raw = (typeName || "").trim();
  if (!raw) return "other";
  if (/^hero$/i.test(raw)) return "hero";
  return raw.toLowerCase();
}

export function deckTypeSectionTitle(typeKey, representativeTypeName) {
  if (typeKey === "hero") return "Heroes";
  if (typeKey === "other") return "Other";
  const rep = (representativeTypeName || "").trim();
  if (rep) return rep;
  return typeKey.replace(/\b\w/g, (c) => c.toUpperCase());
}

export function compareDeckTypeKeys(a, b) {
  const tier = (k) => {
    if (k === "hero") return 0;
    if (DECK_TYPE_ORDER.includes(k)) return 1;
    if (k === "other") return 3;
    return 2;
  };
  const ta = tier(a);
  const tb = tier(b);
  if (ta !== tb) return ta - tb;
  if (ta === 1) return DECK_TYPE_ORDER.indexOf(a) - DECK_TYPE_ORDER.indexOf(b);
  return a.localeCompare(b);
}

export function groupDeckLinesByType(lines) {
  const buckets = new Map();
  for (const line of lines) {
    const raw = line.card?.type_name;
    const key = deckLineTypeKey(raw);
    if (!buckets.has(key)) {
      buckets.set(key, { labelRaw: raw?.trim() || "", lines: [] });
    }
    const bucket = buckets.get(key);
    if (!bucket.labelRaw && raw?.trim()) bucket.labelRaw = raw.trim();
    bucket.lines.push(line);
  }
  for (const bucket of buckets.values()) {
    bucket.lines.sort((x, y) =>
      (x.card?.name || "").localeCompare(y.card?.name || "", undefined, { sensitivity: "base" })
    );
  }
  const sortedKeys = [...buckets.keys()].sort(compareDeckTypeKeys);
  return sortedKeys.map((key) => {
    const b = buckets.get(key);
    const totalQuantity = b.lines.reduce((sum, line) => sum + (line.quantity ?? 0), 0);
    return { key, title: deckTypeSectionTitle(key, b.labelRaw), lines: b.lines, totalQuantity };
  });
}
